import { trpc } from '@/lib/trpc';

const useGetSavedLists = (enabled: boolean = true) => {
	const { data, isLoading, error } = trpc.list.getSaved.useQuery(undefined, {
		enabled,
	});

	return {
		listsSaved: data?.listsSaved || [],
		listsSavedLoading: isLoading,
		listsSavedError: error,
	};
};

export default useGetSavedLists;
